import { render } from "./FollowWelcomeMessage.vue?vue&type=template&id=0dc6392f&scoped=true"
import script from "./FollowWelcomeMessage.vue?vue&type=script&lang=js"
export * from "./FollowWelcomeMessage.vue?vue&type=script&lang=js"

import "./FollowWelcomeMessage.vue?vue&type=style&index=0&id=0dc6392f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc6392f"]])

export default __exports__